angular.module('unergie.main')
.directive('timeline', ($rootScope, AlertManager, DataAccessSearch, TimelineService, BoFeaturesService,
    TimelineConsService, ContractService, ApiUser, ApiCons, Rules, ModalService, ErrorCatcher, AuthService) =>
    ({
        restrict: 'E',
        templateUrl: '/directives/timeline/timeline.html',
        link: {
            post($scope) {
                const dataCache = {}
                const selector = '#vis'
                const vis = document.querySelector(selector)
                $scope.canChooseTimeline = BoFeaturesService.isFeatureOn('canChooseTimeline')
                const tooltip = d3.select('body').append('div').attr('class', 'graph-tooltip').style('opacity', 0)

                function getDCAvailability(contractElec, dcType) {
                    if (!contractElec || !contractElec.prm || !contractElec.dataConsents) {
                        return {
                            available: false,
                            reason: 'Problème technique à signaler à la ⛑',
                        }
                    }

                    if (contractElec.prm.service_level !== 2) {
                        return {
                            available: false,
                            reason: 'Nécessite un Linky niveau 2',
                        }
                    }

                    if (!contractElec.dataConsents.some((dc) => (dc.type || dc.id) === dcType && dc.value)) {
                        return {
                            available: false,
                            reason: "Le client n'a pas donné son accord pour la collecte de données",
                        }
                    }

                    return {
                        available: true,
                    }
                }

                function getListReading(idPrm, mStartDate, mEndDate, offset = 0) {
                    const limit = 1000

                    return DataAccessSearch({
                        neq: ['internal_status=90'],
                        notin: ['distributor_status=CANCELLED,CANCELED,IGNORED,IGNORE,REMOVED'],
                        gte: [`start_date=${mStartDate.toISOString()}`],
                        lt: [`end_date=${mEndDate.toISOString()}`],
                        orderBy: 'start_date,end_date,-temp_class,id',
                        columns: [
                            'id',
                            'start_date',
                            'end_date',
                            'class',
                            'index_nature',
                            'id_calendar',
                            'temp_class',
                            'value',
                            'last_value',
                            'consumption',
                        ],
                        offset,
                        limit,
                    })
                    .searchPaginated({
                        resource: 'readings',
                        id_prm: idPrm,
                    })
                    .$promise
                    .then(({ results: list }) => {
                        if (list.length < limit) {
                            return list
                        }

                        return getListReading(idPrm, mStartDate, mEndDate, offset + limit).then((sublist) => {
                            return list.concat(sublist)
                        })
                    })
                }

                const drawManager = {
                    reading: {
                        label: 'Mensuel',
                        model: {
                            estimated: true,
                            tempClass: {
                                BASE: true,
                                HP: true,
                                HC: true,
                            },
                            nature: {
                                S: false,
                                D: false,
                                F: true,
                            },
                        },
                        fetchData: (contractElec) => {
                            const mStartDate = moment(contractElec.commissioning_date || contractElec.creation_ts).startOf('day')
                            const mEndDate = (contractElec.decommissioning_date)
                                ? moment(contractElec.decommissioning_date).add(2, 'day').startOf('day')
                                : moment().startOf('month').add(2, 'month')

                            return getListReading(contractElec.id_prm, mStartDate, mEndDate).then((data) => {
                                const listReading = data.filter((d) => d.start_date && d.start_date !== d.end_date).map((d) => {
                                    return Object.assign({}, d, {
                                        cons: (d.consumption != null) ? d.consumption : (d.value - d.last_value),
                                        start_date: moment(d.start_date),
                                        end_date: moment(d.end_date),
                                    })
                                })

                                return Promise.resolve().then(() => {
                                    const hasEstimated = (contractElec.estimated_v)
                                    if (!hasEstimated) {
                                        return
                                    }

                                    return ApiCons.estimatedV2({
                                        idContract: contractElec.id,
                                        return: 'daily',
                                        subset: `${mStartDate.format('YYYY-MM-DD')},max-${mEndDate.format('YYYY-MM-DD')}`,
                                    })
                                    .$promise.then((estimated) => {
                                        return Object.assign(estimated, {
                                            daily: estimated.daily.map((day) => {
                                                const flattened = {
                                                    ctc: {},
                                                    sum: null,
                                                }

                                                Object.keys(day).forEach((calendar) => {
                                                    Object.keys(day[calendar]).forEach((tempClass) => {
                                                        flattened.ctc[`${calendar}.${tempClass}`] = day[calendar][tempClass]
                                                    })
                                                })

                                                const listCalendarTempClass = Object.keys(flattened.ctc)
                                                if (listCalendarTempClass.length > 1) {
                                                    flattened.sum = listCalendarTempClass.reduce((acc, ctc) => (acc + flattened.ctc[ctc]), 0)
                                                }

                                                return flattened
                                            }),
                                        })
                                    })
                                })
                                .then((estimated) => {
                                    return {
                                        listReading,
                                        estimated,
                                        mStartDate,
                                        mEndDate,
                                    }
                                })
                            })
                        },
                        draw: (contractElec, model, svg, width, height, data) => {
                            if (!data) {
                                return
                            }

                            return TimelineService.display(svg, width, height, model, data)
                        },
                    },

                    // https://observablehq.com/d/f9a289b551c1e059
                    dcCons: {
                        label: 'Journalier',
                        getAvailability: (contract) => getDCAvailability(contract, 'INDEX'),

                        fetchData: (contract) => {
                            const mStartDate = moment(contract.commissioning_date || contract.creation_ts).startOf('day')
                            const mEndDate = (contract.decommissioning_date)
                                ? moment(contract.decommissioning_date).add(2, 'day').startOf('day')
                                : moment().startOf('month').add(2, 'month')

                            const pDCCons = ApiCons.dcCons({
                                idContract: contract.id,
                                subset: `${mStartDate.format('YYYY-MM-DD')},${mEndDate.format('YYYY-MM-DD')}`,
                            })
                            const pEstimated = (!contract.estimated_v) ? null : ApiCons.estimatedV2({
                                idContract: contract.id,
                                return: 'daily',
                                simplify: true,
                                subset: `${mStartDate.format('YYYY-MM-DD')},max-${mEndDate.format('YYYY-MM-DD')}`,
                            })

                            return Promise.all([
                                pDCCons.$promise,
                                pEstimated && pEstimated.$promise,
                            ])
                            .then(([cons, estimated]) => {
                                cons.forEach((c) => {
                                    const duration = moment(c.timePeriod.endDate).diff(c.timePeriod.startDate, 'day', true)
                                    c.total.sleeked = c.total.value / duration // Wh / j
                                })
                                if (estimated) {
                                    estimated.daily.forEach((e) => {
                                        e.sum = Object.keys(e).reduce((acc, tempClass) => {
                                            return acc + e[tempClass]
                                        }, 0)
                                    })
                                }

                                return {
                                    mStartDate,
                                    mEndDate,
                                    cons,
                                    estimated,
                                }
                            })
                        },

                        draw: (contract, model, svg, width, height, data) => {
                            const margin = {
                                top: 20,
                                right: 30,
                                bottom: 40,
                                left: 40,
                            }

                            const cons = data.cons
                            const estimated = data.estimated
                            const maxValue = Math.max(d3.max(cons, (c) => c.total.sleeked) || 0, (estimated && d3.max(estimated.daily, (d) => d.sum) * 1000) || 0)
                            const x = d3.scaleTime().domain([data.mStartDate, data.mEndDate]).range([margin.left, width - margin.right])
                            const y = d3.scaleLinear().domain([0, 500 + maxValue]).range([height - margin.bottom, margin.top])
                            const length = x(data.mEndDate.valueOf()) - x(data.mStartDate.valueOf())

                            svg.append('g')
                            .attr('class', 'x axis')
                            .attr('transform', `translate(0, ${height - margin.bottom})`)
                            .call(d3.axisBottom(x))
                            .selectAll('g.tick text').each(function (d) {
                                const el = d3.select(this)

                                el.text('')
                                el.append('tspan').text(moment(d).format('DD/MM/YYYY'))
                            })

                            svg.append('g')
                            .attr('class', 'y axis')
                            .attr('transform', `translate(${margin.left}, 0)`)
                            .call(d3.axisLeft(y).tickFormat((d) => d))
                            .selectAll('g.tick').each(function (d) {
                                if (d !== 0) {
                                    d3.select(this).append('line')
                                    .attr('x1', 1)
                                    .attr('x2', length)
                                }
                            })

                            svg.append('g').selectAll().data(cons).join('rect')
                            .attr('class', 'consBar')
                            .attr('x', (d) => x(moment(d.timePeriod.startDate).valueOf()))
                            .attr('y', (d) => y(d.total.sleeked))
                            .attr('width', (d) => x(moment(d.timePeriod.endDate).valueOf() - moment(d.timePeriod.startDate).valueOf()) - x(0))
                            .attr('height', (d) => y(0) - y(d.total.sleeked))
                            .attr('fill', (d) => '#4086bf')
                            .attr('opacity', 0.7)
                            .on('mouseover', (d) => {
                                const mStartDate = moment(d.timePeriod.startDate)
                                const isOneDay = moment(mStartDate).add(1, 'day').isSame(d.timePeriod.endDate)

                                svg.tooltip.transition().duration(200).style('opacity', 0.9)
                                svg.tooltip.html([
                                    `Consommation de ${d.total.value} Wh`,
                                    (isOneDay) ? `le ${mStartDate.format('DD/MM/YYYY')}` : `du ${mStartDate.format('DD/MM/YYYY')}`,
                                    (isOneDay) ? false : `au ${moment(d.timePeriod.endDate).subtract(1, 'day').format('DD/MM/YYYY')} inclus`,
                                ].filter((xx) => xx).join('<br/>'))
                                .style('left', `${d3.event.pageX + 20}px`)
                                .style('top', `${d3.event.pageY - 28}px`)
                            })
                            .on('mouseout', () => svg.tooltip.transition().duration(500).style('opacity', 0))

                            if (estimated) {
                                svg.append('g').selectAll().data(estimated.daily)
                                .join('circle')
                                .attr('r', 2.4)
                                .attr('cx', (d, i) => x(moment(estimated.timePeriod.startDate).add(i, 'day').valueOf()))
                                .attr('cy', (d) => y(d.sum * 1000)) // on convertit l'unité
                                .attr('class', 'sum')
                                .on('mouseover', (d, i) => {
                                    const mDate = moment(estimated.timePeriod.startDate).add(i, 'day')

                                    svg.tooltip.transition().duration(200).style('opacity', 0.9)
                                    svg.tooltip.html([
                                        `Estimation de ${Math.round(d.sum * 1000)} Wh`,
                                        `le ${mDate.format('DD/MM/YYYY')}`,
                                    ].filter((xx) => xx).join('<br/>'))
                                    .style('left', `${d3.event.pageX + 20}px`)
                                    .style('top', `${d3.event.pageY - 28}px`)
                                })
                                .on('mouseout', () => svg.tooltip.transition().duration(500).style('opacity', 0))
                            }

                            return svg
                        },
                    },

                    // https://observablehq.com/d/ccf9952c9795808c
                    dcPower: {
                        label: 'Puissance max.',
                        getAvailability: (contractElec) => getDCAvailability(contractElec, 'INDEX'),

                        fetchData: (contractElec) => {
                            const mStartDate = moment(contractElec.commissioning_date || contractElec.creation_ts).startOf('day')
                            const mEndDate = moment.max(moment(mStartDate).add(1, 'day'), moment().startOf('day'))

                            return ApiCons.dcPower({
                                idContract: contractElec.id,
                                subset: `${mStartDate.format('YYYY-MM-DD')},${mEndDate.format('YYYY-MM-DD')}`,
                            })
                            .$promise.then((power) => {
                                return {
                                    mStartDate,
                                    mEndDate,
                                    power,
                                }
                            })
                        },

                        draw: (contractElec, model, svg, width, height, data) => {
                            const margin = {
                                top: 20,
                                right: 30,
                                bottom: 40,
                                left: 40,
                            }

                            const list = data.power.filter((d) => d && d.power)
                            const maxPower = contractElec.max_power * 1000
                            const maxValue = d3.max(list, (d) => d.power.value) || 0
                            const meterBreakerLimit = (contractElec.prm.meterBreakerLimit || 0) * 1000
                            const x = d3.scaleTime().domain([data.mStartDate, data.mEndDate]).range([margin.left, width - margin.right])
                            const y = d3.scaleLinear().domain([0, Math.max(500 + maxPower, 500 + meterBreakerLimit, maxValue)]).range([height - margin.bottom, margin.top])
                            const barColor = d3.scaleLinear().domain([0, maxPower]).range(['#1467bb', '#61045f'])
                            const length = x(data.mEndDate.valueOf()) - x(data.mStartDate.valueOf())

                            svg.append('g')
                            .attr('class', 'x axis')
                            .attr('transform', `translate(0, ${height - margin.bottom})`)
                            .call(d3.axisBottom(x))
                            .selectAll('g.tick text').each(function (d) {
                                const el = d3.select(this)

                                el.text('')
                                el.append('tspan').text(moment(d).format('DD/MM/YYYY'))
                            })

                            svg.append('g')
                            .attr('class', 'y axis')
                            .attr('transform', `translate(${margin.left}, 0)`)
                            .call(d3.axisLeft(y).tickFormat((d) => d))
                            .selectAll('g.tick').each(function (d) {
                                if (d !== 0 && d !== maxPower) {
                                    d3.select(this).append('line')
                                    .attr('x1', 1)
                                    .attr('x2', length)
                                }
                            })

                            svg.append('g').selectAll().data(list).join('rect')
                            .attr('class', 'powerBar')
                            .attr('x', (d) => x(moment(d.timePeriod.startDate).valueOf()))
                            .attr('y', (d) => y(d.power.value))
                            .attr('width', (d) => Math.max(x(moment(d.timePeriod.endDate).valueOf() - moment(d.timePeriod.startDate).valueOf()) - x(0) - 1, 1))
                            .attr('height', (d) => y(0) - y(d.power.value))
                            .attr('fill', (d) => (((meterBreakerLimit && d.power.value >= meterBreakerLimit) && 'red') || ((d.power.value >= maxPower) ? '#61045f' : barColor(d.power.value))))
                            .attr('opacity', 0.7)
                            .on('mouseover', (d) => {
                                const mStartDate = moment(d.timePeriod.startDate)
                                const isFullDay = moment(mStartDate).add(1, 'day').isSame(d.timePeriod.endDate)

                                svg.tooltip.transition().duration(200).style('opacity', 0.9)
                                svg.tooltip.html([
                                    `Puissance max de ${d.power.value} Watt`,
                                    (isFullDay) ? `le ${mStartDate.format('DD/MM/YYYY')}` : `du ${mStartDate.format('DD/MM/YYYY HH[h]mm')}`,
                                    (isFullDay) ? false : `au ${moment(d.timePeriod.endDate).format('DD/MM/YYYY HH[h]mm')}`,
                                    (d.peakDate) ? `<br/><b>pic atteint le ${moment(d.peakDate).format('DD/MM/YYYY à HH[h]mm')}<b>` : false,
                                ].filter((xx) => xx).join('<br/>'))
                                .style('left', `${d3.event.pageX + 20}px`)
                                .style('top', `${d3.event.pageY - 28}px`)
                            })
                            .on('mouseout', () => svg.tooltip.transition().duration(500).style('opacity', 0))

                            const powerLine = svg.append('g').attr('transform', `translate(${x(data.mStartDate.valueOf())}, ${y(maxPower)})`)
                            powerLine.append('text').attr('class', 'powerLine').attr('transform', `translate(${length - 30}, -4)`).text(`${contractElec.max_power} kVA`)
                            powerLine.append('line')
                            .attr('class', 'powerLine')
                            .attr('x1', 0)
                            .attr('x2', length)
                            .attr('y1', 0)
                            .attr('y2', 0)

                            if (meterBreakerLimit) {
                                const formated = `${contractElec.prm.meterBreakerLimit.toFixed(2)} kVA`
                                const meterBreakerLine = svg.append('g').attr('transform', `translate(${x(data.mStartDate.valueOf())}, ${y(meterBreakerLimit)})`)
                                meterBreakerLine.append('text').attr('class', 'meterBreakerLine').attr('transform', `translate(${length - 30}, -4)`).text(formated)
                                meterBreakerLine.append('line')
                                .attr('class', 'meterBreakerLine')
                                .attr('x1', 0)
                                .attr('x2', length)
                                .attr('y1', 0)
                                .attr('y2', 0)
                            }

                            return svg
                        },
                    },

                    // https://observablehq.com/d/fff5745d23f44fe3
                    dcLoadCurve: {
                        label: 'Puissance moy.',
                        getAvailability: (contractElec) => getDCAvailability(contractElec, 'CURVES'),

                        fetchData: (contractElec) => {
                            const now = moment().startOf('day')
                            const mStartDate = moment(now).subtract(6, 'day')
                            const mEndDate = moment(now).add(0, 'day')

                            return ApiCons.dcLoadCurve({
                                idContract: contractElec.id,
                                subset: `${mStartDate.format('YYYY-MM-DD')},${mEndDate.format('YYYY-MM-DD')}`,
                            })
                            .$promise.then((loadCurve) => {
                                return ApiCons.dcPower({
                                    idContract: contractElec.id,
                                    subset: `${mStartDate.format('YYYY-MM-DD')},${mEndDate.format('YYYY-MM-DD')}`,
                                })
                                .$promise.then((power) => {
                                    return {
                                        mStartDate,
                                        mEndDate,
                                        loadCurve,
                                        power,
                                    }
                                })
                            })
                        },

                        draw: (contractElec, model, svg, width, height, data) => {
                            const margin = {
                                top: 20,
                                right: 30,
                                bottom: 40,
                                left: 40,
                            }

                            const listPower = data.power.filter((d) => d && d.power)
                            const listLoadCurve = data.loadCurve.filter((d) => d && d.loadCurve)
                            const maxPower = contractElec.max_power * 1000
                            const maxValue = d3.max(listLoadCurve, (d) => d.loadCurve.value) || 0
                            const meterBreakerLimit = (contractElec.prm.meterBreakerLimit || 0) * 1000
                            const x = d3.scaleTime().domain([data.mStartDate, data.mEndDate]).range([margin.left, width - margin.right])
                            const y = d3.scaleLinear().domain([0, Math.max(500 + maxPower, 500 + meterBreakerLimit, maxValue)]).range([height - margin.bottom, margin.top])
                            const barColor = d3.scaleLinear().domain([0, maxPower]).range(['#1467bb', '#61045f'])
                            const length = x(data.mEndDate.valueOf()) - x(data.mStartDate.valueOf())

                            svg.append('g')
                            .attr('class', 'x axis')
                            .attr('transform', `translate(0, ${height - margin.bottom})`)
                            .call(d3.axisBottom(x))
                            .selectAll('g.tick text').each(function (d) {
                                const el = d3.select(this)

                                el.text('')
                                el.append('tspan').text(moment(d).format('DD/MM/YYYY'))
                                el.append('tspan').text(moment(d).format('HH[h]mm')).attr('x', 0).attr('dy', '15')
                            })

                            svg.append('g')
                            .attr('class', 'y axis')
                            .attr('transform', `translate(${margin.left}, 0)`)
                            .call(d3.axisLeft(y).tickFormat((d) => d))
                            .selectAll('g.tick').each(function (d) {
                                if (d !== 0 && d !== maxPower) {
                                    d3.select(this).append('line')
                                    .attr('x1', 1)
                                    .attr('x2', length)
                                }
                            })

                            svg.append('g').selectAll().data(listLoadCurve).join('rect')
                            .attr('class', 'consBar')
                            .attr('x', (d) => x(moment(d.timePeriod.startDate).valueOf()))
                            .attr('y', (d) => y(d.loadCurve.value))
                            .attr('width', (d) => Math.max(x(moment(d.timePeriod.endDate).valueOf() - moment(d.timePeriod.startDate).valueOf()) - x(0) - 1, 1))
                            .attr('height', (d) => y(0) - y(d.loadCurve.value))
                            .attr('fill', (d) => {
                                if (!d.loadCurve.qualified) {
                                    return 'orange'
                                }
                                if (meterBreakerLimit && d.loadCurve.value >= meterBreakerLimit) {
                                    return 'red'
                                }
                                if (d.loadCurve.value >= maxPower) {
                                    return '#61045f'
                                }

                                return barColor(d.loadCurve.value)
                            })
                            .attr('opacity', 0.7)
                            .on('mouseover', (d) => {
                                svg.tooltip.transition().duration(200).style('opacity', 0.9)
                                svg.tooltip.html([
                                    `Puissance moyenne de ${d.loadCurve.value} Watt`,
                                    `du ${moment(d.timePeriod.startDate).format('DD/MM/YYYY HH[h]mm')}`,
                                    `au ${moment(d.timePeriod.endDate).format('DD/MM/YYYY HH[h]mm')}`,
                                    (d.loadCurve.qualified) ? false : `<br/><b>valeur sujette à caution<b>`,
                                    (d.loadCurve.qualified) ? false : `d'après Enedis<b>`,
                                ].filter((xx) => xx).join('<br/>'))
                                .style('left', `${d3.event.pageX + 20}px`)
                                .style('top', `${d3.event.pageY - 28}px`)
                            })
                            .on('mouseout', () => svg.tooltip.transition().duration(500).style('opacity', 0))

                            const powerLine = svg.append('g').attr('transform', `translate(${x(data.mStartDate.valueOf())}, ${y(maxPower)})`)
                            powerLine.append('text').attr('class', 'powerLine').attr('transform', `translate(${length - 30}, -4)`).text(`${contractElec.max_power} kVA`)
                            powerLine.append('line')
                            .attr('class', 'powerLine')
                            .attr('x1', 0)
                            .attr('x2', length)
                            .attr('y1', 0)
                            .attr('y2', 0)

                            if (meterBreakerLimit) {
                                const formated = `${contractElec.prm.meterBreakerLimit.toFixed(2)} kVA`
                                const meterBreakerLine = svg.append('g').attr('transform', `translate(${x(data.mStartDate.valueOf())}, ${y(meterBreakerLimit)})`)
                                meterBreakerLine.append('text').attr('class', 'meterBreakerLine').attr('transform', `translate(${length - 30}, -4)`).text(formated)
                                meterBreakerLine.append('line')
                                .attr('class', 'meterBreakerLine')
                                .attr('x1', 0)
                                .attr('x2', length)
                                .attr('y1', 0)
                                .attr('y2', 0)
                            }

                            svg.append('g').selectAll().data(listPower).join('line')
                            .attr('class', 'powerMaxLine')
                            .attr('x1', (d) => x(moment(d.timePeriod.startDate).valueOf()))
                            .attr('x2', (d) => x(moment(d.timePeriod.endDate).valueOf()))
                            .attr('y1', (d) => y(d.power.value))
                            .attr('y2', (d) => y(d.power.value))
                            .on('mouseover', (d) => {
                                svg.tooltip.transition().duration(200).style('opacity', 0.9)
                                svg.tooltip.html([
                                    `Puissance max. de ${d.power.value} Watt`,
                                    `du ${moment(d.timePeriod.startDate).format('DD/MM/YYYY HH[h]mm')}`,
                                    `au ${moment(d.timePeriod.endDate).format('DD/MM/YYYY HH[h]mm')}`,
                                ].filter((xx) => xx).join('<br/>'))
                                .style('left', `${d3.event.pageX + 20}px`)
                                .style('top', `${d3.event.pageY - 28}px`)
                            })
                            .on('mouseout', () => svg.tooltip.transition().duration(500).style('opacity', 0))

                            return svg
                        },
                    },

                    cdaStandbyConsumption: {
                        label: 'Veille ⛑',
                        hide: !AuthService.userHasGroup('data-admin'),
                        getAvailability: (contractElec) => getDCAvailability(contractElec, 'CURVES'),

                        fetchData: (contractElec) => {
                            const mStartDate = moment(contractElec.commissioning_date || contractElec.creation_ts).startOf('day')
                            const mEndDate = (contractElec.decommissioning_date)
                                ? moment(contractElec.decommissioning_date).add(2, 'day').startOf('day')
                                : moment().startOf('month').add(2, 'month')

                            return ApiCons.searchCDA({
                                'appliesTo.idContract': contractElec.id,
                                'analysis.type': 'CDA_STANDBY_CONSUMPTION',
                            })
                            .$promise.then((analysis) => {
                                return {
                                    mStartDate,
                                    mEndDate,
                                    analysis,
                                }
                            })
                        },

                        draw: (contractElec, model, svg, width, height, data) => {
                            const margin = {
                                top: 20,
                                right: 30,
                                bottom: 40,
                                left: 40,
                            }

                            const listAnalysis = data.analysis
                            const maxValue = d3.max(listAnalysis, (d) => d.analysis.result.avg) || 0
                            const x = d3.scaleTime().domain([data.mStartDate, data.mEndDate]).range([margin.left, width - margin.right])
                            const y = d3.scaleLinear().domain([0, Math.max(500, maxValue)]).range([height - margin.bottom, margin.top])
                            const length = x(data.mEndDate.valueOf()) - x(data.mStartDate.valueOf())

                            svg.append('g')
                            .attr('class', 'x axis')
                            .attr('transform', `translate(0, ${height - margin.bottom})`)
                            .call(d3.axisBottom(x))
                            .selectAll('g.tick text').each(function (d) {
                                const el = d3.select(this)

                                el.text('')
                                el.append('tspan').text(moment(d).format('DD/MM/YYYY'))
                            })

                            svg.append('g')
                            .attr('class', 'y axis')
                            .attr('transform', `translate(${margin.left}, 0)`)
                            .call(d3.axisLeft(y).tickFormat((d) => d))
                            .selectAll('g.tick').each(function (d) {
                                if (d !== 0) {
                                    d3.select(this).append('line')
                                    .attr('x1', 1)
                                    .attr('x2', length)
                                }
                            })

                            svg.append('g').selectAll().data(listAnalysis).join('rect')
                            .attr('class', 'consBar')
                            .attr('x', (d) => x(moment(d.timePeriod.startDate).valueOf()))
                            .attr('y', (d) => y(d.analysis.result.avg))
                            .attr('width', (d) => Math.max(x(moment(d.timePeriod.endDate).valueOf() - moment(d.timePeriod.startDate).valueOf()) - x(0) - 1, 1))
                            .attr('height', (d) => y(0) - y(d.analysis.result.avg))
                            .attr('fill', '#1467bb')
                            .attr('opacity', 0.7)
                            .on('mouseover', (d) => {
                                svg.tooltip.transition().duration(200).style('opacity', 0.9)
                                svg.tooltip.html([
                                    `Puissance de veille de ${Math.round(d.analysis.result.avg)} Watt`,
                                    `du ${moment(d.timePeriod.startDate).format('DD/MM/YYYY')}`,
                                    `au ${moment(d.timePeriod.endDate).format('DD/MM/YYYY')}`,
                                ].filter((xx) => xx).join('<br/>'))
                                .style('left', `${d3.event.pageX + 20}px`)
                                .style('top', `${d3.event.pageY - 28}px`)
                            })
                            .on('mouseout', () => svg.tooltip.transition().duration(500).style('opacity', 0))

                            return svg
                        },
                    },
                }

                $scope.modes = Object.keys(drawManager).filter((id) => !drawManager[id].hide).map((id) => ({
                    id,
                    label: drawManager[id].label || id,
                }))
                $scope.mode = $scope.modes[0].id



                function draw(reset, thenRedraw) {
                    const mode = $scope.mode
                    const manager = drawManager[mode]
                    const contractElec = $scope.currentContract

                    if (contractElec.id_account === $scope.account.id) {
                        $scope.refreshingGraph = true
                        if (reset) {
                            $scope.model = (manager.model) ? _.cloneDeep(manager.model) : null
                        }

                        return Promise.resolve().then(() => {
                            if (!reset && dataCache.idContract === contractElec.id && dataCache.mode === mode) {
                                return dataCache.data
                            }

                            return manager.fetchData(contractElec).then((data) => {
                                Object.assign(dataCache, {
                                    idContract: contractElec.id,
                                    mode,
                                    data,
                                })

                                return data
                            })
                        })
                        .then((data) => {
                            const width = vis.getBoundingClientRect().width
                            const height = 325
                            const svg = d3.create('svg').attr('width', width).attr('height', height).attr('class', `graph graph-${mode}`)
                            svg.tooltip = tooltip

                            manager.draw(contractElec, $scope.model, svg, width, height, data)
                            if (thenRedraw && manager.redraw) {
                                manager.redraw($scope.model, svg)
                            }
                            d3.select(vis).selectAll('svg').remove()
                            d3.select(vis).append(() => svg.node())
                        })
                        .catch((error) => {
                            d3.select(vis).selectAll('svg').remove()
                            return console.error(`draw '${mode}'`, error)
                        })
                        .finally(() => {
                            $scope.refreshingGraph = false
                        })
                    }
                }

                function redraw() {
                    const manager = drawManager[$scope.mode]

                    if (manager.redraw) {
                        const svg = d3.select(vis).select('svg')
                        manager.redraw($scope.model, svg)
                    }
                    else {
                        draw(false)
                    }
                }



                ContractService.watch('timeline', (contractElec) => {
                    $scope.mode = $scope.modes[0].id
                    $scope.currentContract = contractElec

                    $scope.availability = _.mapValues(drawManager, (manager) => {
                        if (manager.getAvailability == null) {
                            return { available: true }
                        }

                        return manager.getAvailability($scope.currentContract)
                    })

                    return draw(true)
                })

                if (window.ResizeObserver) {
                    const rsObserver = new window.ResizeObserver((listResized) => {
                        listResized.forEach((e) => {
                            if (e.contentRect.height > 0) {
                                draw(false, true)
                            }
                        })
                    })
                    rsObserver.observe(vis)
                }

                $scope.draw = draw
                $scope.redraw = redraw
            },
        },
    })
)
